import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import InputGroup from '../InputGroup';
import NumberFormat from 'react-number-format';

const useStyles = makeStyles(theme => ({
  input: {
    '& div': {
      background: theme.palette.white
    }
  },
  disabled: {
    '& div': {
      background: 'none'
    }
  }
}));

const InputFormat = ({ value, label, title, placement, placeholder, useTooltip, onChange, fullWidth, name, isRequired,
  error, helperText, rows, multiline, inputProps, disabled, classNameInputGroup, type, min, step, showHelperText, format, mask, showInputGroup }) => {

  const classes = useStyles();
  const defaultHelperText = helperText? helperText : 'O campo é obrigatório';
  
  return (
    showInputGroup ?
      <InputGroup
        label={label}
        placement={placement}
        title={title}
        useTooltip={useTooltip}
        isRequired={isRequired}
        className={classNameInputGroup}
      >
        <NumberFormat 
          customInput={TextField} 
          format={format}
          fullWidth={fullWidth}
          error={error}
          helperText={error || showHelperText? defaultHelperText : ''}
          margin="dense"
          name={name}
          onChange={onChange}
          placeholder={placeholder ? placeholder : label}
          value={value}
          variant="outlined"
          rows={rows}
          multiline={multiline}
          InputProps={inputProps}
          disabled={disabled}
          className={clsx(classes.input, disabled && classes.disabled)}
          type={type}
          min={min}
          step={step}
          mask={mask}
        />
      </InputGroup>
      : 
      <NumberFormat 
        customInput={TextField} 
        format={format}
        fullWidth={fullWidth}
        error={error}
        helperText={error || showHelperText? defaultHelperText : ''}
        margin="dense"
        name={name}
        onChange={onChange}
        placeholder={placeholder ? placeholder : label}
        value={value}
        variant="outlined"
        rows={rows}
        multiline={multiline}
        InputProps={inputProps}
        disabled={disabled}
        className={clsx(classes.input, disabled && classes.disabled)}
        type={type}
        min={min}
        step={step}
        mask={mask}
      />
  )
}

InputFormat.propTypes = {
  children: PropTypes.node,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  isRequired: PropTypes.any,
  multiline: PropTypes.bool,
  placeholder: PropTypes.string,
  placement: PropTypes.string,
  rows: PropTypes.number,
  title: PropTypes.string,
  useTooltip: PropTypes.bool,
  value: PropTypes.string,
  inputProps: PropTypes.object,
  disabled: PropTypes.bool,
  classNameInputGroup: PropTypes.string,
  type: PropTypes.string,
  min: PropTypes.string,
  step: PropTypes.string,
  showHelperText: PropTypes.bool,
  format: PropTypes.string,
  mask: PropTypes.string,
  showInputGroup: PropTypes.bool
};

InputFormat.defaultProps = {
  error: false,
  fullWidth: true,
  helperText: '',
  label: '',
  multiline: false,
  placement: 'top',
  rows: 1,
  title: '',
  useTooltip: false,
  isRequired: false,
  value: '',
  inputProps: {},
  disabled: false,
  classNameInputGroup: '',
  type: 'text',
  placeholder: null,
  onChange: () => {},
  name: '',
  min: null,
  step: null,
  showHelperText: false,
  format: '',
  mask: '',
  showInputGroup: true
};

export default InputFormat;